// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1JTmH","productName":"Table_productName__3F9a_"};